import { FC } from 'react';
import { DisputeChevron, DisputeCountPill } from './DisputeZoneChip';
import { DisputeTaggedText } from './DisputeTaggedText';

interface DisputeFunnelRowProps {
  label: string;
  count: number;
  subtitle?: string;
  onClick?: () => void;
  showChevron?: boolean;
}

const DisputeFunnelRow: FC<DisputeFunnelRowProps> = ({ label, count, subtitle, onClick, showChevron = false }) => (
  <button
    type="button"
    className="relative flex w-full items-center py-2.5 pr-9 pl-4 text-left disabled:cursor-default"
    onClick={onClick}
    disabled={!onClick}
    aria-label={`${label}, ${count}`}>
    <span className="flex min-w-0 flex-1 flex-col items-start">
      <span className="text-sbase text-primaryText">{label}</span>
      {subtitle ? (
        <span className="mt-0.5 text-px13 text-accentText">
          <DisputeTaggedText text={subtitle} />
        </span>
      ) : null}
    </span>
    <span className="shrink-0">
      <DisputeCountPill count={count} isTappable={Boolean(onClick)} />
    </span>
    {showChevron ? (
      <span className="absolute top-1/2 right-3 -translate-y-1/2" aria-hidden="true">
        <DisputeChevron />
      </span>
    ) : null}
  </button>
);

export default DisputeFunnelRow;
